import React, { Component } from "react";
import LeftSideNavigation from "../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import Form from "react-bootstrap/Form";

import CasualDiningManagementScreen from "./MainScreenTabScreen/CasualDiningManagementScreen";
import FastFoodOtherScreen from "./MainScreenTabScreen/FastFoodOtherScreen";
import { HospitalityHotelManagementScreen } from "./MainScreenTabScreen/HospitalityHotelManagementScreen";
import MultiServiceManagementScreen from "./MainScreenTabScreen/MultiServiceManagementScreen";

import { BackLogoIconButton } from "../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { MobileTopHeader } from "../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { TopTextReusableComponent } from "../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { DesktopTabDesign } from "./MainScreenTabScreen/DesktopTabDesign";
import { MobileTabDesign } from "./MainScreenTabScreen/MobileTabDesign";
import Media from "react-media";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
// import {
//   get_new_subscription_for_vendor,
//   update_new_subscription_for_vendor,
// } from "../../../../store/actions/authAction";
import {
  admin_get_new_subscription_for_vendor,
  admin_update_new_subscription_for_vendor,
} from "../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import isEmpty from "../../../store/validation/is-Empty";
import store from "../../../store/store";
import { CLEAR_LOADER, UPDATE_SUBSCRIPTION_TYPE } from "../../../store/types";

export class MainSubscriptionScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      localizationText: "+91IN",
      /********** Tab Management **********/
      casualDiningManagement: true,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
      multiSelectServices: false,

      casual_dining: true,
      fast_food_dining: false,
      hospitality_hotels: false,
      multi_service_business: false,
    };
  }

  componentDidMount() {
    let token = this.props?.auth?.user?.accessToken;
    let adminVendorId = this.props?.editDataAction
      ? this.props?.editData?.vendor_id
      : JSON.parse(localStorage.getItem("vendorId"));
      console.log(adminVendorId,"iddddddddddd",this.props?.editData?.vendor_id);
    const formData = {
      vendor_id: adminVendorId,
    };
    if (adminVendorId !== null || adminVendorId !== undefined) {
      this.props.admin_get_new_subscription_for_vendor(
        token,
        formData.vendor_id
      );
      this.setState({
        vendor_id: formData.vendor_id,
      });
    }
    this.setState({
      casual_dining: this.props?.subscriptionData?.casual_dining,
        // this.props?.tabSubscriptionType?.casualDiningManagement === undefined
        //   ? this.props?.subscriptionData?.casual_dining
        //   : this.props?.tabSubscriptionType?.casualDiningManagement,
      fast_food_dining: this.props?.subscriptionData?.fast_food_dining,
        // this.props?.tabSubscriptionType?.fastFoodOthersManagement === undefined
        //   ? this.props?.subscriptionData?.fast_food_dining
        //   : this.props?.tabSubscriptionType?.fastFoodOthersManagement,
      hospitality_hotels: this.props?.subscriptionData?.hospitality_hotels,
        // this.props?.tabSubscriptionType?.hospitalityAndHotelsManagement ===
        // undefined
        //   ? this.props?.subscriptionData?.hospitality_hotels
        //   : this.props?.tabSubscriptionType?.hospitalityAndHotelsManagement,
      multi_service_business: this.props?.subscriptionData?.multi_service_business,
        // this.props?.tabSubscriptionType?.multiSelectServices === undefined
        //   ? this.props?.subscriptionData?.multi_service_business
        //   : this.props?.tabSubscriptionType?.multiSelectServices,
    });
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    let onboarding = nextProps?.editDataAction
      ? nextProps?.editData
      : nextProps?.onboardingData;
    if (
      !isEmpty(onboarding?._id) &&
      !isEmpty(nextProps?.subscriptionData) &&
      !isEmpty(nextProps?.subscriptionData?._id) &&
      !nextState?.hasSetSubscriptionProps
    ) {
      return {
        casual_dining: !isEmpty(nextProps?.subscriptionData?.casual_dining)
          ? nextProps?.subscriptionData?.casual_dining
          : false,
        fast_food_dining: !isEmpty(
          nextProps?.subscriptionData?.fast_food_dining
        )
          ? nextProps?.subscriptionData?.fast_food_dining
          : false,
        hospitality_hotels: !isEmpty(
          nextProps?.subscriptionData?.hospitality_hotels
        )
          ? nextProps?.subscriptionData?.hospitality_hotels
          : false,
        multi_service_business: !isEmpty(
          nextProps?.subscriptionData?.multi_service_business
        )
          ? nextProps?.subscriptionData?.multi_service_business
          : false,
        hasSetSubscriptionProps: true,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  /***********************************************
   * @Desc Tab Next and Back Button Click Handler
   **********************************************/
  tabBackButtonClicked = (e) => {
    if (this.state.multiSelectServices) {
      this.setState({
        casualDiningManagement: false,
        fastFoodOthersManagement: false,
        hospitalityAndHotelsManagement: true,
        multiSelectServices: false,
      });
    } else {
      this.setState({
        casualDiningManagement: true,
        fastFoodOthersManagement: false,
        hospitalityAndHotelsManagement: false,
        multiSelectServices: false,
      });
    }
  };

  tabNextButtonClicked = (e) => {
    if (this.state.hospitalityAndHotelsManagement) {
      this.setState({
        casualDiningManagement: false,
        fastFoodOthersManagement: false,
        hospitalityAndHotelsManagement: false,
        multiSelectServices: true,
      });
    } else {
      this.setState({
        casualDiningManagement: false,
        fastFoodOthersManagement: false,
        hospitalityAndHotelsManagement: true,
        multiSelectServices: false,
      });
    }
  };

  /***********************************************
   * @Desc Tab Button Click Handler
   **********************************************/
  casualDiningManagementButton = (e) => {
    this.setState({
      casual_dining: true,
      fast_food_dining: false,
      hospitality_hotels: false,
      multi_service_business: false,
    });
    const formData = {
      casualDiningManagement: true,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
      multiSelectServices: false,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
  };

  fastFoodOthersManagement = (e) => {
    this.setState({
      casual_dining: false,
      fast_food_dining: true,
      hospitality_hotels: false,
      multi_service_business: false,
    });
    const formData = {
      casualDiningManagement: false,
      fastFoodOthersManagement: true,
      hospitalityAndHotelsManagement: false,
      multiSelectServices: false,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
  };
  hospitalityHotelsManagement = (e) => {
    this.setState({
      casual_dining: false,
      fast_food_dining: false,
      hospitality_hotels: true,
      multi_service_business: false,
    });
    const formData = {
      casualDiningManagement: false,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: true,
      multiSelectServices: false,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
  };
  multiServiceManagementButton = (e) => {
    this.setState({
      casual_dining: false,
      fast_food_dining: false,
      hospitality_hotels: false,
      multi_service_business: true,
    });
    const formData = {
      casualDiningManagement: false,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
      multiSelectServices: true,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
  };

  // onSwitchChange = (event) => {
  //   this.setState({ ...this.state, [event.target.name]: event.target.checked });
  // };

  localProps = {
    casualDiningManagementButton: this.casualDiningManagementButton,
    fastFoodOthersManagement: this.fastFoodOthersManagement,
    hospitalityHotelsManagement: this.hospitalityHotelsManagement,
    multiServiceManagementButton: this.multiServiceManagementButton,
    tabBackButtonClicked: this.tabBackButtonClicked,
    tabNextButtonClicked: this.tabNextButtonClicked,
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    const formData = {};
    console.log(formData);
  };

  render() {
    const {
      casual_dining,
      fast_food_dining,
      hospitality_hotels,
      multi_service_business,
    } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <div
                // id="onboarding-scrollbar"
                // style={{ overflow: "initial" }}
                className="col-12 pl-0 pr-0 onboarding_process_screen_left h-auto new-subscription-onboarding-component"
              >
                <Form noValidate onSubmit={this.onHandleSubmit}>
                  {/* <Media query="(min-width: 992px)">
                    <div className="col-12">
                      <BackLogoIconButton
                        displayBackText={true}
                        workWithLinkORClick={true}
                        notDisplaProgressBar={true}
                        displayArrow={true}
                        backButtonClicked={() =>
                          this.props.history.push(
                            this.props?.editDataAction
                              ? "/admin-edit-subscription"
                              : "/admin-subscription"
                          )
                        }
                      />
                    </div>
                  </Media> */}
                  {/* <Media query="(max-width: 991px)">
                    <MobileTopHeader link={true} onLink={"/subscriptionhome"} />
                  </Media> */}
                  <div className="col-8 onboarding_process_screen-button-map">
                    <div>
                      <TopTextReusableComponent
                        headingText={
                          this.props?.editDataAction
                            ? "Edit Subscription"
                            : "Subscription"
                        }
                        headingParagraph="Enter the information about the food type provided in your restaurant."
                      />
                    </div>
                    <div>
                      <Media query="(min-width: 768px)">
                        <DesktopTabDesign
                          state={this.state}
                          localProps={this.localProps}
                        />
                      </Media>
                      <Media query="(max-width: 767px)">
                        <MobileTabDesign
                          state={this.state}
                          localProps={this.localProps}
                        />
                      </Media>
                    </div>
                    {casual_dining ? (
                      <CasualDiningManagementScreen
                        localProps={this.localProps}
                        state={this.state}
                        backButtonClicked={() =>
                          this.props.history.push(
                            this.props?.editDataAction
                              ? "/admin-edit-subscription"
                              : "/admin-subscription"
                          )
                        }
                      />
                    ) : null || fast_food_dining ? (
                      <FastFoodOtherScreen
                        localProps={this.localProps}
                        state={this.state}
                        backButtonClicked={() =>
                          this.props.history.push(
                            this.props?.editDataAction
                              ? "/admin-edit-subscription"
                              : "/admin-subscription"
                          )
                        }
                        source={"ADMIN"}
                      />
                    ) : null || hospitality_hotels ? (
                      <HospitalityHotelManagementScreen
                        localProps={this.localProps}
                        state={this.state}
                        backButtonClicked={() =>
                          this.props.history.push(
                            this.props?.editDataAction
                              ? "/admin-edit-subscription"
                              : "/admin-subscription"
                          )
                        }
                      />
                    ) : null || multi_service_business ? (
                      <MultiServiceManagementScreen
                        localProps={this.localProps}
                        state={this.state}
                        backButtonClicked={() =>
                          this.props.history.push(
                            this.props?.editDataAction
                              ? "/admin-edit-subscription"
                              : "/admin-subscription"
                          )
                        }
                      />
                    ) : null}
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

MainSubscriptionScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state?.auth,
  errors: state?.errors?.errors,
  onboardingData: state.superAdminOnboarding.restaurantDetails,
  editData: state?.adminAllVendorsInfo?.superAdminMerchantEditInfo,
  editDataAction:
    state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData,
  subscription: state.superAdminOnboarding.onboard_subscription_details,
  subscriptionData:
    state.superAdminOnboarding &&
    state.superAdminOnboarding?.onboard_subscription_details,
  allSubscriptionsData: state.superAdminOnboarding?.onboard_subscription_details,
  tabSubscriptionType: state?.superAdminOnboarding?.subscriptionType,
});

export default connect(mapStateToProps, {
  // update_new_subscription_for_vendor,
  // get_new_subscription_for_vendor,
  admin_update_new_subscription_for_vendor,
  admin_get_new_subscription_for_vendor,
})(withRouter(MainSubscriptionScreen));

// import React, { Component } from "react";
// import Form from "react-bootstrap/Form";
// import LeftSideNavigation from "../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
// import HomeReusableTopBarNavigation from "../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
// // import { SliderReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
// import CasualDiningManagementScreen from "./MainScreenTabScreen/CasualDiningManagementScreen";
// import FastFoodOtherScreen from "./MainScreenTabScreen/FastFoodOtherScreen";
// import { HospitalityHotelManagementScreen } from "./MainScreenTabScreen/HospitalityHotelManagementScreen";
// import PropTypes from "prop-types";
// import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
// import {
//   admin_get_new_subscription_for_vendor,
//   admin_update_new_subscription_for_vendor,
// } from "../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
// import isEmpty from "../../../store/validation/is-Empty";
// import store from "../../../store/store";
// import { CLEAR_LOADER } from "../../../store/types";

// export class AdminViewSubscription extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       vendor_id: "",
//       localizationText: "+91IN",
//       /********** Tab Management **********/
//       casualDiningManagement: true,
//       fastFoodOthersManagement: false,
//       hospitalityAndHotelsManagement: false,

//       casual_dining: true,
//       fast_food_dining: false,
//       hospitality_hotels: false,
//     };
//   }

//   componentDidMount() {
//     let token = this.props?.auth?.user?.accessToken;
//     let adminVendorId = this.props?.editDataAction
//       ? this.props?.editData?.vendor_id
//       : JSON.parse(localStorage.getItem("vendorId"));
//     console.log("ADMIN VENDOR ====>", adminVendorId);
//     const formData = {
//       vendor_id: adminVendorId,
//     };
//     if (adminVendorId !== null || adminVendorId !== undefined) {
//       this.props.admin_get_new_subscription_for_vendor(
//         token,
//         formData.vendor_id
//       );
//       this.setState({
//         vendor_id: formData.vendor_id,
//       });
//     }
//     store.dispatch({
//       type: CLEAR_LOADER,
//     });
//   }

//   static getDerivedStateFromProps(nextProps, nextState) {
//     let onboarding = nextProps?.editDataAction
//       ? nextProps?.editData
//       : nextProps?.onboardingData;
//     if (
//       !isEmpty(onboarding?._id) &&
//       !isEmpty(nextProps.subscriptionData) &&
//       !isEmpty(nextProps.subscriptionData._id) &&
//       !nextState.hasSetSubscriptionProps
//     ) {
//       return {
//         casual_dining: !isEmpty(nextProps.subscriptionData.casual_dining)
//           ? nextProps.subscriptionData.casual_dining
//           : false,
//         fast_food_dining: !isEmpty(nextProps.subscriptionData.fast_food_dining)
//           ? nextProps.subscriptionData.fast_food_dining
//           : false,
//         hospitality_hotels: !isEmpty(
//           nextProps.subscriptionData.hospitality_hotels
//         )
//           ? nextProps.subscriptionData.hospitality_hotels
//           : false,
//         hasSetSubscriptionProps: true,
//       };
//     }
//     if (nextProps.errors !== nextState.errors) {
//       return {
//         errors: nextProps.errors,
//       };
//     }
//     return null;
//   }

//   /***********************************************
//    * @Desc Tab Next and Back Button Click Handler
//    **********************************************/
//   tabBackButtonClicked = (e) => {
//     this.setState({
//       casualDiningManagement: true,
//       fastFoodOthersManagement: false,
//       hospitalityAndHotelsManagement: false,
//     });
//   };

//   tabNextButtonClicked = (e) => {
//     this.setState({
//       casualDiningManagement: false,
//       fastFoodOthersManagement: false,
//       hospitalityAndHotelsManagement: true,
//     });
//   };

//   /***********************************************
//    * @Desc Tab Button Click Handler
//    **********************************************/
//   casualDiningManagementButton = (e) => {
//     this.setState({
//       casual_dining: true,
//       fast_food_dining: false,
//       hospitality_hotels: false,
//     });
//   };
//   fastFoodOthersManagement = (e) => {
//     this.setState({
//       casual_dining: false,
//       fast_food_dining: true,
//       hospitality_hotels: false,
//     });
//   };
//   hospitalityHotelsManagement = (e) => {
//     this.setState({
//       casual_dining: false,
//       fast_food_dining: false,
//       hospitality_hotels: true,
//     });
//   };

//   localProps = {
//     casualDiningManagementButton: this.casualDiningManagementButton,
//     fastFoodOthersManagement: this.fastFoodOthersManagement,
//     hospitalityHotelsManagement: this.hospitalityHotelsManagement,
//     tabBackButtonClicked: this.tabBackButtonClicked,
//     tabNextButtonClicked: this.tabNextButtonClicked,
//   };

//   onHandleSubmit = (e) => {
//     e.preventDefault();
//     const formData = {};
//     console.log(formData);
//   };

//   render() {
//     const { casual_dining, fast_food_dining, hospitality_hotels } = this.state;
//     return (
//       <React.Fragment>
//         <div className="container-fluid">
//           <div className="row">
//             <div className="left-side-panel">
//               <LeftSideNavigation displayLink={1} />
//             </div>
//             <div className="super-admin-right-side-panel">
//               <HomeReusableTopBarNavigation />
//               <div
//                 id="onboarding-scrollbar"
//                 style={{ overflow: "initial" }}
//                 className="col-12 pl-0 pr-0 onboarding_process_screen_left new-subscription-onboarding-component"
//               >
//                 <Form noValidate onSubmit={this.onHandleSubmit}>
//                   {casual_dining ? (
//                     <CasualDiningManagementScreen
//                       localProps={this.localProps}
//                       state={this.state}
//                       backButtonClicked={() =>
//                         this.props.history.push("/admin-subscription")
//                       }
//                     />
//                   ) : null || fast_food_dining ? (
//                     <FastFoodOtherScreen
//                       localProps={this.localProps}
//                       state={this.state}
//                       backButtonClicked={() =>
//                         this.props.history.push("/admin-subscription")
//                       }
//                     />
//                   ) : null || hospitality_hotels ? (
//                     <HospitalityHotelManagementScreen
//                       localProps={this.localProps}
//                       state={this.state}
//                       backButtonClicked={() =>
//                         this.props.history.push("/admin-subscription")
//                       }
//                     />
//                   ) : null}
//                 </Form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </React.Fragment>
//     );
//   }
// }

// AdminViewSubscription.propTypes = {
//   auth: PropTypes.object.isRequired,
//   errors: PropTypes.object.isRequired,
//   subscription: PropTypes.object.isRequired,
//   subscriptionData: PropTypes.object.isRequired,
//   allSubscriptionsData: PropTypes.object.isRequired,
// };

// const mapStateToProps = (state) => ({
//   auth: state.auth,
//   errors: state.errors.errors,
//   onboardingData: state.superAdminOnboarding.restaurantDetails,
//   editData: state?.adminAllVendorsInfo?.superAdminMerchantEditInfo,
//   editDataAction:
//     state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData,

//   subscription: state.superAdminOnboarding.onboard_subscription_details,
//   subscriptionData:
//     state.superAdminOnboarding &&
//     state.superAdminOnboarding.onboard_subscription_details,
//   allSubscriptionsData: state.superAdminOnboarding.onboard_subscription_details,
//   tabSubscriptionType: state?.superAdminOnboarding?.subscriptionType,
// });

// export default connect(mapStateToProps, {
//   admin_update_new_subscription_for_vendor,
//   admin_get_new_subscription_for_vendor,
// })(withRouter(AdminViewSubscription));
